import { createStyles, Theme } from '@material-ui/core'

const HorizontalLineStyles = (theme: Theme) => createStyles({
  wrapper: {
    height: '1px',
    background: '#E3E3E3',
    margin: `${theme.spacing(1) * 2}px 0`,
  },
})

export default HorizontalLineStyles
